import React from 'react';

import { CrewSettlementsList } from '@/modules/Settlements/components/Main/CrewSettlementsList';
import Header from '@/modules/Settlements/components/Main/Header';
import { WorkerSettlementList } from '@/modules/Settlements/components/Main/WorkerSettlementList';
import { SettlementsProvider } from '@/modules/Settlements/context/context';
import { useStore } from '@/shared/hooks/context/createGenericContext';

function Settlements() {
  const [selectedAsset] = useStore((store) => store.asset);

  return (
    <SettlementsProvider>
      <div className='flex flex-col'>
        <Header />
        {selectedAsset?.settlementLevel === 2 ? (
          <WorkerSettlementList />
        ) : (
          <CrewSettlementsList />
        )}
      </div>
    </SettlementsProvider>
  );
}
export { Settlements };
